import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import FormButtons from "./components/form-buttons";
import FormFields from "./components/form-fields";
import useSponsorCreateFormUtil from "./use-sponsor-create-form.util";

const SponsorCreateForm = () => {
  const { onSubmit, validationSchema, isLoading } = useSponsorCreateFormUtil();
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });
  return (
    <div className="w-full">
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormFields control={control} errors={errors} />
        <div className="flex flex-grow items-center justify-end">
          <FormButtons isLoading={isLoading} />
        </div>
      </form>
    </div>
  );
};
export default SponsorCreateForm;
